<template>
  <div class="text-center noshadow">
    <v-dialog v-model="contractDialog" width="90%">
      <template v-slot:activator="{ on }">
        <v-btn block color="primary" dark v-on="on">{{
          selectedLang.ContractDialogTile1
        }}</v-btn>
      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>{{
          selectedLang.ContractDialogTile2
        }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <p style="text-align: justify">
            {{ selectedLang.ContractDialogTile3 }}
          </p>
          <p v-if="user.companions.length && kiofCla != 'TRF' && kiofCla != 'TRFDB'
            " style="text-align: justify">
            {{ selectedLang.ContractDialogTile4 }}
          </p>
          <h2 style="text-align: center">
            {{ selectedLang.ContractDialogTile5 }}
          </h2>
          <h4 style="text-align: center">
            {{ selectedLang.ContractDialogTile6 }}
          </h4>
          <p v-html="formatDBText(selectedLang.ContractDialogTile7, {
            'user.firstName': user.firstName,
            'user.lastName': user.lastName,
            'user.fgebu': user.fgebu,
            'user.address': user.address,
            'user.postalCode': user.postalCode,
            'user.city': user.city,
            'user.state.val': user.state,
          })
            "></p>
          <p style="text-align: right">
            {{ selectedLang.ContractDialogTile7a }}
          </p>
          <p>{{ selectedLang.ContractDialogTile7b }}</p>
          <p v-html="selectedLang.ContractDialogTile7c"></p>
          <p style="text-align: right">
            {{ selectedLang.ContractDialogTile8 }}
          </p>
          <h4>{{ selectedLang.ContractDialogTile9 }}</h4>
          <div>
            <p v-if="kiofCla != 'TRF' && kiofCla != 'TRFDB'" style="text-align: justify" v-html="formatDBText(selectedLang.ContractDialogTile10, {
              'dataFS.flN': dataFS.flN,
              'dataFS.times.pubDLFD': dataFS.times.pubDLFD,
              'dataFS.airports.startAirport.fsidAN':
                dataFS.airports.startAirport.fsidAN,
              'dataFS.airports.targetAirport.fsidAN':
                dataFS.airports.targetAirport.fsidAN,
              'dataFS.airline.name': dataFS.airline.name,
            })
              "></p>
            <p v-else v-html="ContractDialogTile10a"></p>
          </div>
          <div v-if="kiofCla == 'C'">
            <p style="text-align: justify" v-html="formatDBText(selectedLang.ContractDialogTile11, {
              'dataFS.times.pubALFD': dataFS.times.pubALFD,
              'dataFS.times.pubALFT': dataFS.times.pubALFT,
              'dataFS.airports.targetAirport.fsidAN':
                dataFS.airports.targetAirport.fsidAN,
            })
              "></p>
          </div>
          <div v-if="kiofCla == 'L'">
            <p style="text-align: justify" v-html="formatDBText(selectedLang.ContractDialogTile12, {
              'dataFS.airports.targetAirport.fsidAN':
                dataFS.airports.targetAirport.fsidAN,
              'dataFS.times.pubALFD': dataFS.times.pubALFD,
              'dataFS.times.pubALFT': dataFS.times.pubALFT,
              'dataFS.times.actALFD': dataFS.times.actALFD,
              'dataFS.times.actALFT': dataFS.times.actALFT,
            })
              "></p>
          </div>
          <div v-if="kiofCla == 'NB'">
            <p style="text-align: justify" v-html="formatDBText(selectedLang.ContractDialogTile13, {
              'dataFS.airports.targetAirport.fsidAN':
                dataFS.airports.targetAirport.fsidAN,
              'dataFS.times.pubALFD': dataFS.times.pubALFD,
              'dataFS.times.pubALFT': dataFS.times.pubALFT,
            })
              "></p>
          </div>
          <div v-if="kiofCla == 'TRF' || kiofCla == 'TRFDB'">
            <p style="text-align: justify">
              {{ selectedLang.ContractDialogTile13a }}
            </p>
          </div>
          <div>
            <p style="text-align: justify" v-html="formatDBText(selectedLang.ContractDialogTile14, {
              IncidentDativ: IncidentDativ,
            })
              "></p>
            <h4>{{ selectedLang.ContractDialogTile15 }}</h4>
            <p style="text-align: justify" v-html="formatDBText(selectedLang.ContractDialogTile16, {
              'dataEP.anspr': dataEP.anspr,
            })
              "></p>
            <h4>{{ selectedLang.ContractDialogTile17 }}</h4>
            <p style="text-align: justify" v-html="formatDBText(selectedLang.ContractDialogTile18, {
              IncidentSein: IncidentSein,
            })
              "></p>
            <h4>{{ selectedLang.ContractDialogTile19 }}</h4>
            <p style="text-align: justify">
              {{ selectedLang.ContractDialogTile20 }}
            </p>
            <ul style="list-style-type: none">
              <div v-if="kiofCla != 'TRF' && kiofCla != 'TRFDB'">
                <li v-html="formatDBText(selectedLang.ContractDialogTile21, {
                  'dataEP.sCase': dataEP.sCase,
                })
                  "></li>
              </div>
              <div v-if="kiofCla == 'TRF' || kiofCla == 'TRFDB'">
                <li>{{ selectedLang.ContractDialogTile21a }}</li>
              </div>
              <li>{{ selectedLang.ContractDialogTile22 }}</li>
              <div v-if="kiofCla != 'TRF' && kiofCla != 'TRFDB'">
                <li>{{ selectedLang.ContractDialogTile23 }}</li>
              </div>
              <div v-if="kiofCla == 'TRF' || kiofCla == 'TRFDB'">
                <li>{{ selectedLang.ContractDialogTile23a }}</li>
              </div>
              <li v-html="ContractDialogTile24"></li>
              <li v-html="formatDBText(selectedLang.ContractDialogTile25, {
                IncidentGenitiv: IncidentGenitiv,
                Incident: Incident,
              })
                "></li>
              <li>{{ selectedLang.ContractDialogTile26 }}</li>
              <li>{{ selectedLang.ContractDialogTile27 }}</li>
              <div v-if="kiofCla != 'TRF'">
                <li>{{ selectedLang.ContractDialogTile28 }}</li>
              </div>
              <div v-if="kiofCla == 'TRF'">
                <li>{{ selectedLang.ContractDialogTile28a }}</li>
              </div>
              <div v-if="kiofCla == 'C'">
                <li>{{ selectedLang.ContractDialogTile29 }}</li>
              </div>
              <div v-if="kiofCla == 'L'">
                <li>{{ selectedLang.ContractDialogTile30 }}</li>
              </div>
              <div v-if="kiofCla == 'TRF' || kiofCla == 'TRFDB'">
                <li>{{ ContractDialogTile30a }}</li>
              </div>
            </ul>
            <p style="text-align: justify">
              {{ selectedLang.ContractDialogTile31 }}
            </p>
            <p style="text-align: justify">
              {{ selectedLang.ContractDialogTile32 }}
            </p>
            <h4>{{ selectedLang.ContractDialogTile33 }}</h4>
            <p style="text-align: justify" v-html="selectedLang.ContractDialogTile34"></p>
            <p style="text-align: justify">
              {{ selectedLang.ContractDialogTile35 }}
            </p>
            <p style="text-align: justify">
              {{ selectedLang.ContractDialogTile36 }}
            </p>
            <p style="text-align: justify" v-html="formatDBText(selectedLang.ContractDialogTile37, {
              'user.sex': user.sex,
              'user.lastName': user.lastName,
            })
              "></p>
            <h3 style="text-align: center">
              {{ selectedLang.ContractDialogTile38 }}
            </h3>
            <div>
              <p v-if="kiofCla != 'TRF' && kiofCla != 'TRFDB'" style="text-align: justify" v-html="formatDBText(selectedLang.ContractDialogTile39, {
                'user.firstName': user.firstName,
                'user.lastName': user.lastName,
                'user.fgebu': user.fgebu,
                'user.address': user.address,
                'user.postalCode': user.postalCode,
                'user.city': user.city,
                'user.state.val': user.state,
                'dataFS.flN': dataFS.flN,
                'dataFS.times.pubDLFD': dataFS.times.pubDLFD,
                'dataFS.airports.startAirport.fsidAN':
                  dataFS.airports.startAirport.fsidAN,
                'dataFS.airports.targetAirport.fsidAN':
                  dataFS.airports.targetAirport.fsidAN,
                'dataFS.airline.name': dataFS.airline.name,
              })
                "></p>
              <p v-else style="text-align: justify" v-html="ContractDialogTile39a"></p>
            </div>
            <h3 style="text-align: center">
              {{ selectedLang.ContractDialogTile40 }}
            </h3>
            <p style="text-align: justify">
              <i>{{ selectedLang.ContractDialogTile41 }}</i>
            </p>
            <p style="text-align: justify" v-html="selectedLang.ContractDialogTile42"></p>
            <p style="text-align: justify" v-html="selectedLang.ContractDialogTile43"></p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" block @click="contractDialog = false">{{
            selectedLang.ContractDialogTile44
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "PersonalDataTile",
  data: function () {
    return {
      contractDialog: false,
      Incident: "",
      IncidentGenitiv: "",
      IncidentDativ: "",
      IncidentSein: "",
      ContractDialogTile1: "",
      ContractDialogTile10a: "",
      ContractDialogTile10b: "",
      ContractDialogTile13a: "",
      ContractDialogTile24: "",
      ContractDialogTile30a: "",
      ContractDialogTile39a: "",
    };
  },
  computed: {
    ...mapState([
      "user",
      "dataFS",
      "dataEP",
      "kiofCla",
      "selectedLang",
      "dataTrain",
    ]),
  },
  mounted: function () {
    if (this.kiofCla != "TRFDB") {
      this.dataFS.times.pubDLFD = this.dateFormat(this.dataFS.times.pubDL);
      this.dataFS.times.pubALFD = this.dateFormat(this.dataFS.times.pubAL);
      this.dataFS.times.pubALFT = this.timeFormat(this.dataFS.times.pubAL);
      this.dataFS.times.actALFD = this.dateFormat(this.dataFS.times.actAL);
      this.dataFS.times.actALFT = this.timeFormat(this.dataFS.times.actAL);
    }
    if (this.kiofCla == "TRF" || this.kiofCla == "TRFDB") {
      this.Incident = this.selectedLang.ContractDialogTile10e;
      this.IncidentGenitiv = this.selectedLang.ContractDialogTile10g;
      this.IncidentDativ = this.selectedLang.ContractDialogTile10i;
      this.IncidentSein = this.selectedLang.ContractDialogTile10k;
    } else {
      this.Incident = this.selectedLang.ContractDialogTile10d;
      this.IncidentGenitiv = this.selectedLang.ContractDialogTile10f;
      this.IncidentDativ = this.selectedLang.ContractDialogTile10h;
      this.IncidentSein = this.selectedLang.ContractDialogTile10j;
    }

    this.ContractDialogTile24 = this.formatDBText(
      this.selectedLang.ContractDialogTile24,
      {
        IncidentDativ: this.IncidentDativ,
      }
    );

    if (this.kiofCla == "TRF") {
      if (this.dataEP.rfFlN == "") {
        this.ContractDialogTile10b = "";
      } else {
        this.ContractDialogTile10b = this.formatDBText(
          this.selectedLang.ContractDialogTile10b,
          {
            returnFlightNumber: this.dataEP.rfFlN,
            returnFlightDate: this.dataEP.sDRF,
          }
        );
      }
      this.ContractDialogTile1 = this.selectedLang.ContractDialogTile1;
      this.ContractDialogTile10a = this.formatDBText(
        this.selectedLang.ContractDialogTile10a,
        {
          "dataFS.flN": this.dataFS.flN,
          "dataFS.times.pubDLFD": this.dataFS.times.pubDLFD,
          "dataFS.airports.startAirport.fsidAN":
            this.dataFS.airports.startAirport.fsidAN,
          "dataFS.airports.targetAirport.fsidAN":
            this.dataFS.airports.targetAirport.fsidAN,
          "selectedLang.ContractDialogTile10b": this.ContractDialogTile10b,
          Incident: this.Incident,
          "dataFS.airline.name": this.dataFS.airline.name,
          IncidentGenitiv: this.IncidentGenitiv,
        }
      );
      this.ContractDialogTile13a = this.selectedLang.ContractDialogTile13a;
      this.ContractDialogTile30a = this.selectedLang.ContractDialogTile30a;
      this.ContractDialogTile39a = this.formatDBText(
        this.selectedLang.ContractDialogTile39a,
        {
          "user.firstName": this.user.firstName,
          "user.lastName": this.user.lastName,
          "user.fgebu": this.user.fgebu,
          "user.address": this.user.address,
          "user.postalCode": this.user.postalCode,
          "user.city": this.user.city,
          "user.state.val": this.user.state,
          "dataFS.flN": this.dataFS.flN,
          "dataFS.times.pubDLFD": this.dataFS.times.pubDLFD,
          "dataFS.airports.startAirport.fsidAN":
            this.dataFS.airports.startAirport.fsidAN,
          "dataFS.airports.targetAirport.fsidAN":
            this.dataFS.airports.targetAirport.fsidAN,
          "selectedLang.ContractDialogTile10b": this.ContractDialogTile10b,
          "dataFS.airline.name": this.dataFS.airline.name,
        }
      );
    } else if (this.kiofCla == "TRFDB") {
      if (this.dataTrain.trCancelDirection == "both") {
        this.ContractDialogTile10b = this.formatDBText(
          this.selectedLang.ContractDialogTile10bDB,
          {
            start: this.dataTrain.start,
          }
        );
      } else {
        this.ContractDialogTile10b = "";
      }
      this.ContractDialogTile1 = this.selectedLang.ContractDialogTile1DB;
      this.ContractDialogTile10a = this.formatDBText(
        this.selectedLang.ContractDialogTile10aDB,
        {
          bookingCode: this.dataTrain.bookingCode,
          "dataTrain.travelDate": this.dataTrain.travelDate,
          start: this.dataTrain.start,
          destination: this.dataTrain.destination,
          ContractDialogTile10bDB: this.ContractDialogTile10b,
          Incident: this.Incident,
          IncidentGenitiv: this.IncidentGenitiv,
        }
      );
      this.ContractDialogTile13a = this.selectedLang.ContractDialogTile13aDB;
      this.ContractDialogTile24 = this.formatDBText(
        this.selectedLang.ContractDialogTile24DB,
        {
          IncidentDativ: this.IncidentDativ,
        }
      );
      this.ContractDialogTile30a = this.selectedLang.ContractDialogTile30aDB;
      this.ContractDialogTile39a = this.formatDBText(
        this.selectedLang.ContractDialogTile39aDB,
        {
          "user.firstName": this.user.firstName,
          "user.lastName": this.user.lastName,
          "user.fgebu": this.user.fgebu,
          "user.address": this.user.address,
          "user.postalCode": this.user.postalCode,
          "user.city": this.user.city,
          "user.state.val": this.user.state,
          bookingCode: this.dataTrain.bookingCode,
          "dataTrain.travelDate": this.dataTrain.travelDate,
          start: this.dataTrain.start,
          destination: this.dataTrain.destination,
          ContractDialogTile10b: this.ContractDialogTile10b,
        }
      );
    }
  },
  methods: {
    formatDBText(str, values) {
      var result;
      var reg = /(\w+.?\w+.?\w+.?\w+)(?= }})/g;
      while ((result = reg.exec(str)) !== null) {
        let key = String(str).match(reg)[0];
        if (Object.keys(values).includes(key)) {
          str = str.replace("{{ " + key + " }}", values[key]);
        }
      }
      result = str;
      return result;
    },
    dateFormat(date) {
      const event = new Date(date);
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };
      return event.toLocaleDateString("de-DE", options);
    },
    timeFormat(date) {
      const event = new Date(date);
      const optionst = {
        hour: "2-digit",
        minute: "2-digit",
      };
      return event.toLocaleTimeString("de-DE", optionst);
    },
  },
};
</script>
